import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SubMenu from "../../../Menu/SubMenu";
import EmperorTentBanner, { InfoValue } from "../../../Common/EmperorTentBanner";
import {
  Crime,
  GovernyInfo,
  ThiefActionType,
  Upgrade
} from "../../../../lib/types";
import { DragescentState } from "../../../../store/reducers/stateType";
import { getData } from "../../../../lib/commonFunctions";
import { initEmperorTentState } from "../../../../store/actions";
import { setSameHeight } from "../../../../lib/elementUtilities";
import CrimesSection from "./CrimesSection";
import InnerLoader from "../../../Common/InnerLoader";
import Counterintelligence from "./Counterintellingence";
import DialogButton from "../../../Common/DialogButton";
import { UPGRADES } from "../../../../lib/enums";
import { icons } from "../../../../assets/images/icons";

const ThievesEmperorTent = () => {
  const govRef = useRef(null);

  const [selectedMember, setSelectedMember] = useState<GovernyInfo | null>(null);
  const race = useSelector((state: DragescentState) => state.governorate.race);
  const alliance = useSelector((state: DragescentState) => state.governorate.alliance);
  const data = useSelector((state: DragescentState) => state.emperorTent);
  const thievesEmperorTentUpgrade = useSelector((state: DragescentState) => state
    .governorate.upgrades.find((u: Upgrade) => u.id === UPGRADES.ThievesEmperorTent));
  const thievesEmperorTent = useSelector(
    (state: DragescentState) => state.governorate.thievesEmperorTent
  );
  const credits = useSelector((state: DragescentState) => state.governorate.player.credits);

  const dispatch = useDispatch();

  useEffect(() => {
    if (alliance) {
      getData(`/api/emperorTent/data/thieves`)
        .then((emperorTentData) => {
          dispatch(initEmperorTentState(emperorTentData));
          if (!selectedMember) {
            setSelectedMember(emperorTentData.members[0]);
          }
          setSameHeight(govRef.current || undefined);
        });
    }

    return () => {
      dispatch(initEmperorTentState())
    };
  }, []);

  useEffect(() => {
    if (selectedMember && data.members) {
      setSelectedMember(data.members.find(m => m.id === selectedMember.id) || data.members[0]);
    }
  }, [data.members?.reduce((sum: number, m) => sum += m.resources.gold, 0)])

  const ThievesEmperorTentSubMenu = () => <SubMenu
    tabs={[
      {
        name: "Thieves",
        title: "Thieves",
        icon: "zlodeji",
        label: "Crimes",
        active: false,
        parameters: {
          reload: true
        }
      },
      {
        name: "ThievesEmperorTent",
        title: "Thieves",
        icon: "zlodeji",
        label: "Emperor Tent",
        active: true,
        parameters: {
          reload: false
        }
      }
    ]}
  />

  if (!thievesEmperorTent) {
    return <>
      <ThievesEmperorTentSubMenu/>
      <div className="box">
        <div className="row">
          <div className="col-md-12 text-center">
            <div className="text-bigger">
              Thieves emperor tent allows you to send crimes for all members of your alliance.
            </div>
            <p>Thieves emperor tent not purchased</p>
            <DialogButton
              dialogOptions={{
                name: "PurchaseUpgrade",
                header: "Thieves emperor tent",
                id: UPGRADES.ThievesEmperorTent,
                params: {},
                question: "Purchase Thieves emperor tent?",
                purchasable: !(credits < thievesEmperorTentUpgrade.price),
                price: thievesEmperorTentUpgrade.price
              }}
            >
              GET <img src={icons.credit} alt=""/>
            </DialogButton>
          </div>
        </div>
      </div>
      <span className="divider"/>
    </>
  }

  if (!alliance) {
    return <>
      <ThievesEmperorTentSubMenu />
      <div className="box">
        <div className="row">
          <div className="col-md-12 text-center">
            <div className="text-bigger">
              Army emperor tent can be used only in alliances.
            </div>
          </div>
        </div>
      </div>
      <span className="divider"/>
    </>
  }

  return (
    <section className="boxes-group">
      <ThievesEmperorTentSubMenu />
      {data && data.members && selectedMember ? <>
        <div className="box text-center padding">
          <div className="row persons generals" ref={govRef}>
            {data.members.map(member => <EmperorTentBanner
              id={member.id}
              name={member.name}
              race={member.race}
              info={{
                [InfoValue.TURNS]: `${member.turn}/${member.maxTurns}`,
                [InfoValue.ATTACK]: (member.generals?.thief?.general?.attack.sum || 0).toString(),
                [InfoValue.DEFENCE]: (member.generals?.thief?.general?.defence.sum || 0).toString(),
                [InfoValue.GOLD]: `${member.resources.gold}`,
                [InfoValue.CRIMES_LIMIT]: `${member.limitingCrimes}/${member.crimesLimit}`
              }}
              setUpAction={() => setSelectedMember(member)}
              active={selectedMember?.id === member.id}
            />)}
            {data.members.length < 4 && new Array(4 - data.members.length).fill("").map(() => <EmperorTentBanner
              info={{
                [InfoValue.TURNS]: "-",
                [InfoValue.ATTACK]: "-",
                [InfoValue.DEFENCE]: "-",
                [InfoValue.GOLD]: "-",
                [InfoValue.CRIMES_LIMIT]: "-"
              }}
              active={false}
            />)}
          </div>
        </div>
        <span className={"divider"} />

        {selectedMember.opponent && selectedMember.generals.thief.general
        && <section className={selectedMember.race.name}>
          {!selectedMember.readyToThieves && <>
            <div className="box text-info">
              <p>
                <span className="negative">
                  Thievish actions and crimes are not available until 8th turn and out of war.
                  {!selectedMember.generals.thief.general
                    ? " You need thief general for orchestration of your thieves." : ""}
                </span>
              </p>
            </div>
            <span className={"divider"} />
          </>}
          <h2 className="h2 h2-first">
            <span className="bordered">Crimes</span>
          </h2>
          <span className="divider"/>
          <CrimesSection
            sender={selectedMember.id}
            gold={selectedMember.resources.gold}
            readyToThieves={selectedMember.readyToThieves}
            crimeTypes={selectedMember.crimeTypes
              .filter((crime: ThiefActionType) => crime.id !== 8)}
            limitingCrimes={selectedMember.limitingCrimes}
            crimesLimit={selectedMember.crimesLimit}
            crimes={selectedMember.crimes}
            opponent={selectedMember.opponent}
          />
          <span className="divider"/>

          <h2 className="h2 h2-first">
            <span className="bordered">Counterintelligence</span>
          </h2>
          <span className="divider"/>
          <div className="box">
            <p className="text-info text-center js-message-wrap">
              {(selectedMember.limitingCrimes >= selectedMember.crimesLimit
              && !selectedMember.canSendCounterintelligence) ? "Governorate has reached crimes limit" : ""}
            </p>
            <table className="table vertical-top">
              <thead>
              <tr>
                <th className="text-left">Governorate</th>
                <th className="text-left">State</th>
              </tr>
              </thead>
              <tbody>
              {
                data.members
                  .filter((member: GovernyInfo) => member.id !== selectedMember.id)
                  .map((member: GovernyInfo) => <Counterintelligence
                    sender={selectedMember.id}
                    gold={selectedMember.resources.gold}
                    disabled={!selectedMember.readyToThieves
                    && (selectedMember.limitingCrimes >= selectedMember.crimesLimit
                      && !selectedMember.canSendCounterintelligence)}
                    target={member}
                    counterintelligence={selectedMember.crimes
                      .find((crime: Crime) => crime.target.id === member.id)}
                    counterintelligenceType={selectedMember.crimeTypes
                      .filter(crime => crime.id === 8)[0]}
                  />)
              }
              </tbody>
            </table>
          </div>
          <span className={"divider"} />
        </section>}
      </> : <InnerLoader race={race.name}/>}
    </section>
  )
}

export default ThievesEmperorTent;
